<template>
  <nuttrema-layout-page-content class="is-login">

    <nuttrema-loader
      v-if="RegionalAndLanguageAll.fetching">
    </nuttrema-loader>

    <form-login
       v-else
       theme="global"
       class="is-section-transparent is-no-center-scroll is-center-vertical"
      :error="error"
      :create-instance="true"
      :PersonalProfile="PersonalProfile"
      :RegionalAndLanguageAll="RegionalAndLanguageAll"
      @emailChanged="onEmailChange"
      @changeLanguage="onChangeLanguage"
      @submit="onSubmit"
      @forgot-password="onForgotPassword">
    </form-login>

    <template slot="footer">
      <nuttrema-footer></nuttrema-footer>
    </template>

  </nuttrema-layout-page-content>
</template>

<script>
import NuttremaLayoutPageContent from 'components/ui/layout/nuttrema-layout-page-content';
import NuttremaFooter from 'components/ui/panels/nuttrema-footer';

import PageLogin from 'components/pages/shared/login/page-login';

export default {
  name: 'page-professional-login',
  mixins: [
    PageLogin,
  ],
  components: {
    NuttremaFooter,
    NuttremaLayoutPageContent,
  },
  methods: {
    onForgotPassword() {
      this.$router.push({ name: this.PAGES.PROFESSIONAL.FORGOT_PASSWORD });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/public/login/page-professional-login.vue